const SELECTOR_TEXT_CONTAINER = '.banner-text';
const ID_GUTSCHEINCODE = 'gutscheincode';
const ID_GUTSCHEINBEDINGUNGEN = 'gutscheinbedingungen';

const COOKIE_NAME_HAT_ABO = 'hatAbo';
const COOKIE_NAME_GUTHABEN = 'anzahlGuthaben';

const TEXT_KEIN_GUTHABEN = 'Zum Abo-Preis kaufen';
const TEXT_GUTHABEN = ' Guthaben verfügbar';

const ABODATEN_CHANGED_EVENT = "abodaten.changed";

const SELECTOR_BANNER_LINK = '.banner-link';

class BannerOnsiteMarketing extends HTMLElement {

    connectedCallback() {
        this.setElements();
        this.bindEvents();
        if (this.dataset.abofaehig === "true") {
            this.initAboZeile();
        }
    }

    setElements() {
        this.kopierenButton = this.querySelector('.button-gutscheincode');
        this.gutscheinCode = this.querySelector('.gutscheincode')?.innerHTML;
        this.statusText = this.querySelector('.banner-kopieren-status');

        this.overlay = this.querySelector('.overlay-onsite');
        this.overlayOeffnenButton = this.querySelector('.open-overlay-onsite');
        this.overlaySchliessenButtonList = this.querySelectorAll('.close-overlay-onsite');

        this.bannerTextContainer = this.querySelector(SELECTOR_TEXT_CONTAINER);
        this.defaultText = this.bannerTextContainer.innerHTML;
        this.defaultTextPlain = this.bannerTextContainer.textContent;

        this.bannerLink = this.querySelector(SELECTOR_BANNER_LINK);
    }

    bindEvents() {
        this.kopierenButton?.addEventListener('click', () => this.codeKopieren());
        this.overlayOeffnenButton?.addEventListener('click', () => this.overlayOeffnen());
        this.overlaySchliessenButtonList.forEach((button) => {
            button.addEventListener('click', () => this.overlaySchliessen())
        });
        window.addEventListener(ABODATEN_CHANGED_EVENT, () => {
            this.initAboZeile();
        });
    }

    codeKopieren = async () => {
        try {
            await navigator.clipboard.writeText(this.gutscheinCode);
            this.toggleStatusAnzeige();
        } catch (err) {
            // Zwischenablage nicht verfügbar - Status bleibt unverändert
        }
    }

    toggleStatusAnzeige() {
        this.statusText?.removeAttribute('hidden');
        setTimeout(() => {
            this.statusText?.setAttribute('hidden', 'hidden');
        }, "3000");
    }

    overlayOeffnen() {
        this.overlay.showModal();
    }

    overlaySchliessen() {
        this.overlay.close();
    }

    initAboZeile() {
        this.readCookieValues();
        this.changeText();
    }

    readCookieValues() {
        this.hatAbo = this.getCookie(COOKIE_NAME_HAT_ABO) === 'true';
        if (this.hatAbo) {
            this.anzahlGuthaben = parseFloat(this.getCookie(COOKIE_NAME_GUTHABEN));
        } else {
            this.anzahlGuthaben = 0;
        }
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    changeText() {
        if (this.hatAbo) {
            let guthabenText = this.anzahlGuthaben > 0 ? `${this.anzahlGuthaben.toLocaleString()}${TEXT_GUTHABEN}` : TEXT_KEIN_GUTHABEN;
            this.bannerTextContainer.innerHTML = guthabenText;
            const gutscheincode = document.getElementById(ID_GUTSCHEINCODE);
            if (gutscheincode) {
                gutscheincode.remove();
            }
            const gutscheinbedingungen = document.getElementById(ID_GUTSCHEINBEDINGUNGEN);
            if (gutscheinbedingungen) {
                gutscheinbedingungen.remove();
            }
            this.setAttribute('promotion-creative', guthabenText);
            this.removeBannerLink();
        } else {
            this.bannerTextContainer.innerHTML = this.defaultText;
            this.setAttribute('promotion-creative', this.defaultTextPlain);
        }
    }

    removeBannerLink() {
        if (this.bannerLink) {
            this.bannerLink.remove();
        }
    }
}

if (!customElements.get("banner-onsite-marketing")) {
    customElements.define("banner-onsite-marketing", BannerOnsiteMarketing);
}
